import { DataTypes } from "./DataTypes";

const initialData = [
    {
        id: "0",
        title: "Eye catching thumbnail | get views",
        imgUrl: "https://i.pinimg.com/originals/dd/a1/2c/dda12c587120e5e4378a01f31e812672.jpg",
        userId: "John Doe",
        views: "5.5M",
        days: 15,
        duration: "10:00",
    },
    {
        id: "1",
        title: "How to make youtube video",
        imgUrl: "https://www.techsmith.com/blog/wp-content/uploads/2021/02/TSC-thumbnail-example-1024x576.png",
        userId: "Jane Doe",
        views: "75M",
        days: 10,
        duration: "20:00",
    },
    {
        id: "2",
        title: "Eye catching thumbnail | get views",
        imgUrl: "https://i.pinimg.com/originals/dd/a1/2c/dda12c587120e5e4378a01f31e812672.jpg",
        userId: "Sarah Smith",
        views: "35.5M",
        days: 2,
        duration: "05:00",
    },
    {
        id: "3",
        title: "Get more views with better thumbnails",
        imgUrl: "https://i.ytimg.com/vi/ALWfqj3q8gA/maxresdefault.jpg",
        userId: "Dusty H.",
        views: "2M",
        days: 25,
        duration: "11:00",
    },
    {
        id: "4",
        title: "How to get people click",
        imgUrl: "https://i.ytimg.com/vi/is4Ly64MrhI/maxresdefault.jpg",
        userId: "Kate Spring",
        views: "9M",
        days: 25,
        duration: "07:00",
    },
    {
        id: "5",
        title: "Better thumbnail 5 tips",
        imgUrl: "https://i.ytimg.com/vi/2jA4pY334BE/maxresdefault.jpg",
        userId: "John Doe",
        views: "4M",
        days: 17,
        duration: "08:00",
    },
    {
        id: "6",
        title: "How to make great youtube thumbnails",
        imgUrl: "https://i.ytimg.com/vi/-K2Lo5RojBE/maxresdefault.jpg",
        userId: "James Stone",
        views: "65M",
        days: 2,
        duration: "08:00",
    },
    {
        id: "7",
        title: "Eye catching thumbnail | get views",
        imgUrl: "https://i.pinimg.com/originals/dd/a1/2c/dda12c587120e5e4378a01f31e812672.jpg",
        userId: "John Doe",
        views: "5.5M",
        days: 15,
        duration: "10:00",
    },
    {
        id: "8",
        title: "How to make youtube video",
        imgUrl: "https://www.techsmith.com/blog/wp-content/uploads/2021/02/TSC-thumbnail-example-1024x576.png",
        userId: "Jane Doe",
        views: "75M",
        days: 10,
        duration: "20:00",
    },
    {
        id: "9",
        title: "Eye catching thumbnail | get views",
        imgUrl: "https://i.pinimg.com/originals/dd/a1/2c/dda12c587120e5e4378a01f31e812672.jpg",
        userId: "Sarah Smith",
        views: "35.5M",
        days: 2,
        duration: "05:00",
    },
    {
        id: "10",
        title: "Get more views with better thumbnails",
        imgUrl: "https://i.ytimg.com/vi/ALWfqj3q8gA/maxresdefault.jpg",
        userId: "Dusty H.",
        views: "2M",
        days: 25,
        duration: "11:00",
    },
    {
        id: "11",
        title: "How to get people click",
        imgUrl: "https://i.ytimg.com/vi/is4Ly64MrhI/maxresdefault.jpg",
        userId: "Kate Spring",
        views: "9M",
        days: 25,
        duration: "07:00",
    },
    {
        id: "12",
        title: "Better thumbnail 5 tips",
        imgUrl: "https://i.ytimg.com/vi/2jA4pY334BE/maxresdefault.jpg",
        userId: "John Doe",
        views: "4M",
        days: 17,
        duration: "08:00",
    },
];

export const Data: DataTypes = {
    data: [{ name: "foo", age: "88", address: "npj" }],
    setData: () => {},
    hideNav: false,
    setHideNav: () => {},
    desktopView: false,
    setDesktopView: () => {},
    showFullSideBarMenu: true,
    setShowFullSideBarMenu: () => {},
    darkTheme: false,
    setDarkTheme: () => {},
    content: initialData,
    setContent: () => {},
};
